import { Icon, Tag } from '@deque/cauldron-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getFilterLabels } from '../../common/hooks/useIssuesFilter';
import styles from './TestSummary.css';
import type {
  FilteredUserFlowResults,
  Filters
} from '@deque/axe-devtools-issues-utils';

interface UserFlowSummaryProps {
  results: FilteredUserFlowResults;
  filters: Filters;
}

const UserFlowSummary: React.FC<UserFlowSummaryProps> = ({
  results,
  filters
}) => {
  const { t } = useTranslation();

  const filterLabels = getFilterLabels(t);
  const rulesetFilter =
    filters.configAccessibilityStandard || filters.configWCAGLevel;
  const rulesetName =
    filterLabels.configAccessibilityStandard.values.get(rulesetFilter);

  const initialUrl = results.pageStateResults[0].url;

  return (
    <div className={styles.wrap}>
      <dl>
        <div>
          <dt>{t('Starting URL:')}</dt>
          <dd>
            <a href={initialUrl} target="_blank" rel="noopener noreferrer">
              {initialUrl}
              <Icon type="external-link" label={t('Open in new tab')} />
            </a>
          </dd>
        </div>
      </dl>
      <div className={styles.filters}>
        <Tag data-testid="accessibility-standard-filter">{rulesetName}</Tag>
      </div>
    </div>
  );
};

export default UserFlowSummary;
